import { Component, OnInit } from '@angular/core';
import * as xlsx from 'xlsx';
import { InvoiceService } from 'src/app/services/invoice.service';
import { Company } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { AccessService } from 'src/app/services/access.service';
import { DatePipe } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-reprint-invoice-massive',
  templateUrl: './reprint-invoice-massive.component.html',
  styleUrls: ['./reprint-invoice-massive.component.scss'],
  providers: [UtilsService, InvoiceService, CompanyService, AccessService]
})
export class ReprintInvoiceMassiveComponent implements OnInit {
  loading;
  pipeFecha = new DatePipe('en-US');
  company = {} as Company;
  public isReprint: boolean;
  public isDisabled: boolean;
  public begDate: string;
  public endDate: string;
  public userCode: number;
  public storeCode: number;
  public companyCode: number;
  public storeName: string;
  public entries: number = 10;
  public activeRow: any;
  public temp = new Array();
  public invoiceList: any[] = new Array();
  public totalDownload: number = 0;
  public totalErrors: number = 0;

  public settings = {
    columns: {
      fecha: { title: 'Fecha' },
      correlativo: { title: 'Correlativo' },
      cliente: { title: 'Cliente' },
      comentario: { title: 'Tipo' },
      invoiceAuthorization: { title: 'CDC' },
      Estado: { title: 'Estado DNIT' },
      total: { title: 'Total', type: 'number' }
    }
  };

  constructor(
    private _utilsService: UtilsService,
    private _invoiceService: InvoiceService,
    private _companyService: CompanyService,
    private _accessService: AccessService
  ) { }

  async ngOnInit() {
    const _data = JSON.parse(localStorage.getItem('data'));
    this.storeName = _data.storeName ? _data.storeName.toString() : null;
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    this.begDate = this._utilsService.dateTime('yyy-MM-dd');
    this.endDate = this._utilsService.dateTime('yyy-MM-dd');

    this.isReprint = false;
    await this.getCompany(this.companyCode);
  }

  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    const val = $event.target.value.toLowerCase();
    this.temp = this.invoiceList.filter(d => {
      for (const key in d) {
        if (d[key] !== null && d[key].toString().toLowerCase().indexOf(val) !== -1) {
          return true;
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => console.log(error)
    );
  }

  getAll() {
    this.totalDownload = 0;
    this.totalErrors = 0;
    this.isDisabled = true;

    if (!this.begDate || !this.endDate) {
      this.isDisabled = false;
      this._utilsService.showNotification(2, 'Ingresar Datos');
      return;
    }

    this.loading = true;
    const json = { storeCode: this.storeCode, begDate: this.begDate, endDate: this.endDate };

    this._invoiceService.getAllByCompany(json).then(
      async (response) => {
        if (response.result == true) {
          this.invoiceList = response.records.map(invoice => ({
            ...invoice,
            estado: invoice.estado === 'ACTIVO' ? 'AUTORIZADO' : invoice.estado,
            notacredito: invoice.invoiceStatus === 2 ? 'TIENE NC' : 'NO TIENE NC',
            total: Math.floor(invoice.total),
            comentario: invoice.comentario === '' ? 'NORMAL' : invoice.comentario,
            downloadStatus: '',
          }));
          await this._utilsService.orderDate(this.invoiceList, 'fecha', '-');
          this.invoiceList.sort((a, b) => a.invoiceInternNumber - b.invoiceInternNumber);
          this.temp = this.invoiceList;
          this.isReprint = true;
          this.isDisabled = false;
          this._utilsService.showNotification(1, response.message);
        } else {
          this.isDisabled = false;
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this.isDisabled = false;
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => { this.loading = false; });
  }

  async downloadInvoiceMassive() {
    this.totalDownload = 0;
    this.totalErrors = 0;
    this.isDisabled = true;

    for (const row of this.temp) {
      this.loading = true;
      try {
        const response: any = await this._invoiceService.getMegaLocalPY(this.buildBody(row));
        await this.downloadUrlS3(response.records.url, row.invoiceAuthorization, 'pdf');
        this.totalDownload++;
        row.downloadStatus = 'Exitoso';
        this._utilsService.showNotification(1, 'Factura descargada: ' + row.correlativo);
      } catch (error) {
        this.totalErrors++;
        row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
        this._utilsService.showNotification(2, 'Error en correlativo ' + row.correlativo + ': ' + error);
        console.log('Error row:', row, error);
      } finally {
        this.loading = false;
        this.temp = [...this.temp];
      }
      await new Promise(resolve => setTimeout(resolve, 2000));
    }

    this.isDisabled = false;
    this._utilsService.showNotification(1, `Proceso finalizado. Descargadas: ${this.totalDownload}, Errores: ${this.totalErrors}`);
  }

  async searchInvoice($event, row) {
    $event.preventDefault();
    this.loading = true;
    this.isDisabled = true;

    try {
      const response: any = await this._invoiceService.getMegaLocalPY(this.buildBody(row));
      await this.downloadUrlS3(response.records.url, row.invoiceAuthorization, 'pdf');
      row.downloadStatus = 'Exitoso';
      this._utilsService.showNotification(1, 'Factura Generada Correctamente');
    } catch (error) {
      row.downloadStatus = typeof error === 'string' ? error : (error.message || JSON.stringify(error));
      this._utilsService.showNotification(2, error);
      console.log(error);
    } finally {
      this.temp = [...this.temp];
      this.loading = false;
      this.isDisabled = false;
    }
  }

  private buildBody(row: any) {
    const invoiceType = row.comentario === 'Exenta' ? 'FACTEX' : 'FACT';
    return {
      invoice: {
        invoiceCode: row.id,
        cdc: row.invoiceAuthorization,
        invoiceType
      },
      transmitter: {
        transmitterPrefix: this.company.companyPrefix,
        transmitterToken: this.company.companyToken
      }
    };
  }

  async downloadUrlS3(urlFirmada: string, nombreFile: string, format: string) {
    const response = await fetch(urlFirmada);
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = urlBlob;
    link.download = nombreFile + '.' + format;
    link.click();
    window.URL.revokeObjectURL(urlBlob);
  }

  async downloadToExcel() {
    const exportFile = new Array<any>();
    this.temp.forEach(element => {
      let json = {};
      Object.keys(this.settings.columns).forEach(item => {
        if (this.settings.columns[item].type === 'number') {
          json[this.settings.columns[item].title] = parseFloat(element[item]);
        } else {
          json[this.settings.columns[item].title] = element[item];
        }
      });
      exportFile.push(json);
    });
    const ws: xlsx.WorkSheet = xlsx.utils.json_to_sheet(exportFile);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'Reporte');
    xlsx.writeFile(wb, 'reporte-descarga-masiva.xlsx');
  }
}
